module.exports = __webpack_public_path__ + "f981ce2ed6eb6faf8a9b24dbfc7a5a39.pdf";